import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import "./customerTransparency.scss";

const CustomerTransparency = () => {
  return (
    <Container>
      <Box className="ct-container">
        {/* Header Section */}
        <Box className="ct-header">
          <div className="ct-newcd">
            <Box className="ct-number">4</Box>
            <Typography className="ct-title">
           Data Security, Compliance & Trust as Differentiators 
            </Typography>
          </div>

          <Typography className="ct-subtitle">
          As BFSI organizations become more digital,  <span>cybersecurity and regulatory compliance</span> <br /> are more important than ever. 
          </Typography>

         
        </Box>

        {/* Content Section - List LEFT, Image RIGHT */}
        <Grid container spacing={4} className="ct-content">
          {/* Left List */}
          <Grid item xs={12} md={6}>
            <Typography className="hd">
              With Salesforce Shield, organizations can: 
            </Typography>
            <ul className="ct-list">
              <li>
              Ensure data encryption and governance  
              </li>
              <li>
                Track field-level changes with audit trails  
              </li>
              <li>
               Monitor events for suspicious activity  
              </li>
              <li>
                Maintain compliance with regulatory standards
              </li>
            </ul>
          </Grid>

          {/* Right Image */}
          <Grid item xs={12} md={6} className="ct-image-wrapper">
            <Box className="ct-image-box">
              <img src="/images/datasecurity.webp" alt="transparency illustration" />
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Cards */}
        <Grid container spacing={3} className="ct-bottom">
          <Grid item xs={12} md={6}>
            <Typography className="ct-card-title">UTIL Insight</Typography>
            <Box className="ct-card">
              <Typography>
                <span>Secure banking</span>  platforms are critical for digital trust.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography className="ct-card-title">Business Impact</Typography>
            <Box className="ct-card">
              <Typography>
               Trust becomes a
                <span> competitive advantage,</span>
                not just a requirement. 
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CustomerTransparency;
